import React from "react";
import Grid from "@material-ui/core/Grid";

import styles from "./size-info.module.scss";
import image from "../../../assets/images/size-info/bomber.png";

function Bomber() {
  return (
    <Grid container className={styles.sizeInfo}>
      <Grid item xs={12}>
        <h2 className={styles.sizeInfoTitle}>
          Возьмите Вашу любимую кофту/толстовку/свитшот и проведите измерения:
        </h2>
      </Grid>
      <Grid item xs={12} md={4} className={styles.sizeInfoImage}>
        <img src={image} />
      </Grid>
      <Grid item xs={12} md={8}>
        <ol>
          <li>Измерьте длину спины по центру (с).</li>
          <li>
            Измерьте ширину плеч от шва до шва, как указано на рисунке в таблице
            размеров (d).
          </li>
          <li>Измерьте ширину рукава в месте, где он пришит (e).</li>
          <li>Измерьте длину рукава от шва до низа (f).</li>
          <li>
            В нашей таблице размеров найдите показатели, которые наиболее точно
            соответствуют получившимся цифрам.
          </li>
        </ol>
      </Grid>
    </Grid>
  );
}

Bomber.propTypes = {};

export default Bomber;
